import {useEffect, useState} from "react";
import VideoController, {BaseUnrealController, newStateId} from "./VideoController";
import useUnrealUri from "./UnrealContentProvider";
import {BigScreenAboutOn2} from "./pages/pageDescriptors";
import {useVisualizerSession} from "../components/visualizer/VscVisualizerSession";
import {IShow3DOptions} from "../components/visualizer/VisualizerSessionManager";



export interface IActorTrigger {
    C: string; // ActorClass
    T:string; // Tag
    F:string; // Function
    P:string[]; // Parameters

}


const BigScreenWebPage: React.FC<{uri:string}> = (props) => {
    const { uri } = props;
    const sessionManager = useVisualizerSession();

    useEffect(() => {
        let stateIndex = newStateId();
        sessionManager.browse(stateIndex, uri);
    }, [uri]);
    return null;
}

export const DefaultBigScreenPage: React.FC<{}> = (props) => {

    return <BigScreenWebPage uri={BigScreenAboutOn2} />
}

export default BigScreenWebPage;


